import { render, staticRenderFns } from "./ChatPrivateVideo.vue?vue&type=template&id=1f533f31&scoped=true"
import script from "./ChatPrivateVideo.vue?vue&type=script&lang=js"
export * from "./ChatPrivateVideo.vue?vue&type=script&lang=js"
import style0 from "./ChatPrivateVideo.vue?vue&type=style&index=0&id=1f533f31&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f533f31",
  null
  
)

export default component.exports